import React, { useState } from "react";
import { Loader2, ShieldCheck, AlertCircle, ArrowRightLeft } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function DomainTransfer() {
  const [domain, setDomain] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!domain.trim() || code.trim().length < 4) {
      toast.error("Enter a domain and a valid EPP/auth code (4+ chars)");
      return;
    }
    setLoading(true);
    setResult(null);
    try {
      const { data } = await api.post("/domains/transfer/check", {
        domain: domain.trim().toLowerCase(),
        auth_code: code.trim(),
      });
      setResult(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Transfer check failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card p-6" data-testid="domain-transfer-card">
      <div className="flex items-center gap-2 mb-1">
        <ArrowRightLeft size={18} className="text-cyan-300" />
        <h3 className="text-lg font-semibold text-white">Transfer a domain to Optivize</h3>
      </div>
      <p className="text-sm text-slate-400 mb-4">
        Bring your existing domain over. Enter the domain and the EPP/auth code from your current registrar.
      </p>
      <form onSubmit={submit} className="grid sm:grid-cols-[1fr_1fr_auto] gap-2">
        <input
          data-testid="transfer-domain-input"
          value={domain}
          onChange={(e) => setDomain(e.target.value)}
          placeholder="yourbrand.com"
          className="input"
        />
        <input
          data-testid="transfer-code-input"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="EPP / Auth Code"
          className="input"
        />
        <button type="submit" disabled={loading} className="btn-primary !py-2.5" data-testid="transfer-check-btn">
          {loading ? <Loader2 size={16} className="animate-spin" /> : "Check"}
        </button>
      </form>

      {result && (
        <div className="mt-4 text-sm" data-testid="transfer-result">
          {result.eligible ? (
            <div className="flex items-start gap-2 text-emerald-300">
              <ShieldCheck size={16} className="mt-0.5" />
              <div>
                <div className="font-medium">{result.domain} is eligible for transfer.</div>
                {!result.live && (
                  <div className="text-amber-300/80 text-xs mt-0.5">{result.message}</div>
                )}
              </div>
            </div>
          ) : (
            <div className="flex items-start gap-2 text-rose-300">
              <AlertCircle size={16} className="mt-0.5" />
              <div>Not eligible. {result.message || result.raw?.message || "Check the auth code and try again."}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
